import { render } from "./ProgramPage.vue?vue&type=template&id=768a9dd0&scoped=true"
import script from "./ProgramPage.vue?vue&type=script&lang=js"
export * from "./ProgramPage.vue?vue&type=script&lang=js"

import "./ProgramPage.vue?vue&type=style&index=0&id=768a9dd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-768a9dd0"]])

export default __exports__